import PrivacyIcon from "../../assets/icons/more.svg";

const Privacy = () => {
  return (
    <div className="mt-10">
      <div className="flex items-center">
        <img src={PrivacyIcon} width={28} alt="حریم خصوصی" />
        <h1 className="font-bold mr-3">حریم خصوصی بادی‌بان</h1>
      </div>

      <div className="my-10">
        <p className="text-justify leading-7">
          حفظ حریم خصوصی کاربران برای ما در وب‌سایت "بادی‌بان" از اهمیت بالایی
          برخوردار است. این سیاست‌نامه حریم خصوصی، روشی را که ما اطلاعات شخصی
          شما را جمع‌آوری، استفاده، افشا و محافظت می‌کنیم، شرح می‌دهد. با
          استفاده از خدمات ما، شما با شرایط این سیاست‌نامه موافقت می‌کنید.
        </p>
      </div>

      <div className="my-10">
        <h2 className="font-bold text-lg mb-2 mt-10">
          اطلاعاتی که جمع‌آوری می‌کنیم
        </h2>

        <p className="text-justify leading-7">
          ما ممکن است انواع مختلفی از اطلاعات را از شما جمع‌آوری کنیم، از جمله:
        </p>

        <ul className="my-5 list-inside list-disc">
          <li className="my-2 text-justify">
            اطلاعات شخصی: نام، نام خانوادگی، آدرس ایمیل، شماره تلفن، جنسیت،
            تاریخ تولد و سایر اطلاعاتی که شما به صورت داوطلبانه در اختیار ما
            قرار می‌دهید.
          </li>
          <li className="my-2 text-justify">
            اطلاعات مربوط به سلامت: نتایج آزمایش‌ها، سابقه پزشکی و سایر اطلاعات
            مرتبط با سلامت که برای ارائه خدمات به شما ضروری است.
          </li>
          <li className="my-2 text-justify">
            اطلاعات فنی: آدرس IP، نوع مرورگر، سیستم عامل و سایر اطلاعات فنی که
            به صورت خودکار هنگام بازدید شما از وب‌سایت جمع‌آوری می‌شود.
          </li>
        </ul>
      </div>

      <div className="my-10">
        <h2 className="font-bold text-lg mb-2 mt-10">
          نحوه استفاده از اطلاعات
        </h2>

        <p className="text-justify leading-7">
          ما از اطلاعات جمع‌آوری شده برای اهداف زیر استفاده می‌کنیم:
        </p>

        <ul className="my-5 list-inside list-disc">
          <li className="my-2 text-justify">
            برای ارائه خدمات و پشتیبانی به شما
          </li>
          <li className="my-2 text-justify">برای بهبود تجربه شما در برنامه</li>
          <li className="my-2 text-justify">
            برای ارسال اعلان‌ها و پیام‌های مربوط به برنامه
          </li>
          <li className="my-2 text-justify">
            برای تجزیه و تحلیل داده‌ها و تحقیقات
          </li>
          <li className="my-2 text-justify">
            برای اهداف امنیتی و جلوگیری از تقلب
          </li>
        </ul>
      </div>

      <div className="my-10">
        <h2 className="font-bold text-lg mb-2 mt-10">اشتراک‌گذاری اطلاعات</h2>

        <p className="text-justify leading-7">
          ما اطلاعات شخصی شما را بدون رضایت شما با شخص ثالثی به اشتراک
          نمی‌گذاریم، مگر در موارد زیر:
        </p>

        <ul className="my-5 list-inside list-disc">
          <li className="my-2 text-justify"> با رضایت شما </li>
          <li className="my-2 text-justify"> برای ارائه خدمات به شما </li>
          <li className="my-2 text-justify"> برای پیروی از قانون یا مقررات </li>
          <li className="my-2 text-justify">
            برای محافظت از حقوق و دارایی‌های خود
          </li>
        </ul>
      </div>

      <div className="my-10">
        <h2 className="font-bold text-lg mb-2 mt-10">امنیت اطلاعات شخصی</h2>

        <p className="text-justify leading-7">
          یکی از اولویت‌های اصلی ما در بادی‌بان محافظت از اطلاعات حساب کاربران و
          جلوگیری از دسترسی‌های غیرمجاز به این اطلاعات است. بر همین اساس:
        </p>

        <ul className="my-5 list-inside list-disc">
          <li className="my-2 text-justify">
            تمامی خدمات ما با SSL‌ رمزگذاری شده‌اند.
          </li>
          <li className="my-2 text-justify">
            برای هر بار ورود به حساب کاربری از رمز عبور یک‌بار مصرف (OTP)
            استفاده می‌شود که تنها با دسترسی به شماره تلفن یا ایمیل شما
            امکان‌پذیر است.
          </li>
          <li className="my-2 text-justify">
            علی‌رغم تمام رویه‌های ایمنی که بادی‌بان مطابق با قانون به هنگام
            ارائه خدمات اتخاذ کرده است، متاسفانه تدابیر امنیتی را نمی‌توان به
            صورت صد در صدی تضمین نمود، بنابراین مقتضی است:
            <ul className="my-5 list-inside mr-4 list-disc">
              <li className="my-2 text-justify">
                از اطلاعات حساب کاربری خود محافظت کرده و آن‌ها را در اختیار
                اشخاص ثالث قرار ندهید،
              </li>
              <li className="my-2 text-justify">
                اطلاعات ورود به حساب کاربری خود را برای دیگران به اشتراک
                نگذارید.
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div className="my-10">
        <h2 className="font-bold text-lg mb-2 mt-10">
          تغییرات در سیاست حریم خصوصی:
        </h2>

        <p className="text-justify leading-7">
          این سند مطابق با آخرین تغییرات قوانین و مقررات موضوعه کشور تدوین شده و
          مبیّن کلیه حقوق شما تحت قانون تجارت الکترونیکی مصوب ۱۳۸۲ و اسناد
          بین‌المللی ذیربط است. این سند ممکن است دستخوش تغییرات و تجدیدنظر شود و
          در صورتی که اطلاع‌رسانی تغییرات به موجب قانون الزامی باشد، این تغییرات
          از طریق حساب کاربری به کاربران اطلاع داده خواهد شد.
        </p>
      </div>

      <div className="my-10">
        <h2 className="font-bold text-lg mb-2 mt-10">تماس با ما</h2>

        <p className="text-justify leading-7">
          برای هرگونه سوال یا نگرانی در مورد این سیاست‌نامه، لطفا با ما تماس
          بگیرید.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
